import { ManageDeliverySegmentedControlSelection } from '@src/pages/DeliveryDashboard/components/DashboardManageDelivery';
import { DELIVERY_DASHBOARD_BOTTOM_SHEET_ANIMATION_COMPLETE_GLOBAL_EVENT_NAME } from '@src/pages/DeliveryDashboard/components/DeliveryDashboardBottomSheet';
import { useDashboardUIStore } from '@src/pages/DeliveryDashboard/store/dashboardUIStore';

export const useDashboardOnboardingStepEventHandlers = () => {
  const {
    setBottomSheetForcedSnapHeight,
    setActiveManageDeliveryTab,
    bottomSheetForcedSnapHeight = 0,
    activeManageDeliveryTab,
  } = useDashboardUIStore();

  const cloneElementWithComputedStyles = (element: HTMLElement) => {
    const clone = element.cloneNode(true) as HTMLElement;
    const computedStyle = window.getComputedStyle(element);
    for (let i = 0; i < computedStyle.length; i++) {
      const prop = computedStyle[i] as any;
      clone.style[prop] = computedStyle.getPropertyValue(prop);
    }

    return clone;
  };

  const createMockPresenterElementOverOriginalElement = (
    mockElementId: string,
    sourceElement: HTMLElement
  ) => {
    if (!sourceElement) {
      return;
    }
    window.requestAnimationFrame(() => {
      const copiedElement = cloneElementWithComputedStyles(sourceElement);
      const { left, top } = sourceElement.getBoundingClientRect();
      copiedElement.id = mockElementId;
      copiedElement.style.position = 'absolute';
      copiedElement.style.zIndex = '999999';
      copiedElement.style.left = `${left}px`;
      copiedElement.style.top = `${top}px`;
      document.body.appendChild(copiedElement);
    });
  };

  const step3beforeStepInitializedHandler = () => {
    setBottomSheetForcedSnapHeight(240);
  };

  const step3beforeStepLeaveHandler = () => {
    setBottomSheetForcedSnapHeight(84);
  };

  const step4beforeStepInitializedHandler = () => {
    if (!bottomSheetForcedSnapHeight || bottomSheetForcedSnapHeight < 650) {
      setBottomSheetForcedSnapHeight(650);
    }
  };

  const step5beforeStepInitializedHandler = () => {
    const eventHandler = () => {
      window.requestAnimationFrame(() => {
        const TagElement = document.querySelector(
          '#active-couriers-list [data-qa="tag"]'
        ) as HTMLElement;

        const { x: tagX, y: tagY, width: tagW } = TagElement.getBoundingClientRect();
        const segmentedControlItem = document.querySelector(
          '[data-qa="manage-delivery-segmented-control-item"] label'
        ) as HTMLElement;

        if (segmentedControlItem) {
          createMockPresenterElementOverOriginalElement(
            'segmented-control-item-copy',
            segmentedControlItem
          );
        }

        const target = document.getElementById('active-couriers-list');
        const highlightContainer = document.createElement('div');
        if (target) {
          highlightContainer.id = 'tutorial-marker-higlighter-5';
          highlightContainer.style.width = `${tagW + 35}px`;
          highlightContainer.style.height = '165px';
          highlightContainer.style.position = 'absolute';
          highlightContainer.style.left = `${tagX - 15}px`;
          highlightContainer.style.top = `${tagY - 15}px`;
          document.body.appendChild(highlightContainer);
        }
        window.removeEventListener(
          DELIVERY_DASHBOARD_BOTTOM_SHEET_ANIMATION_COMPLETE_GLOBAL_EVENT_NAME,
          eventHandler
        );
      });
    };
    if (bottomSheetForcedSnapHeight !== 650) {
      window.addEventListener(
        DELIVERY_DASHBOARD_BOTTOM_SHEET_ANIMATION_COMPLETE_GLOBAL_EVENT_NAME,
        eventHandler
      );
    } else {
      setTimeout(eventHandler, 50);
    }

    if (!bottomSheetForcedSnapHeight || bottomSheetForcedSnapHeight < 650) {
      setBottomSheetForcedSnapHeight(650);
    }
  };

  const step5beforeStepLeaveHandler = ({ isMovingToNextPage }: { isMovingToNextPage: Boolean }) => {
    window.requestAnimationFrame(() => {
      const highlightContainer = document.getElementById('tutorial-marker-higlighter-5');
      const segmentedControlItem = document.querySelector(
        '[data-qa="manage-delivery-segmented-control-item"]'
      ) as HTMLElement;
      if (segmentedControlItem) {
        segmentedControlItem.style.position = '';
        segmentedControlItem.style.zIndex = '';
      }
      if (highlightContainer) {
        document.body.removeChild(highlightContainer);
        document.body.removeChild(document.getElementById('segmented-control-item-copy') as any);
      }
    });
    if (isMovingToNextPage) {
      setActiveManageDeliveryTab(ManageDeliverySegmentedControlSelection.ORDERS);
    }
  };

  const step6beforeStepLeaveHandler = () => {
    const copyItem = document.getElementById('segmented-control-item-copy-2') as any;
    if (activeManageDeliveryTab !== ManageDeliverySegmentedControlSelection.COURIERS) {
      setActiveManageDeliveryTab(ManageDeliverySegmentedControlSelection.COURIERS);
    }
    if (copyItem) {
      document.body.removeChild(copyItem);
    }
  };

  const step6beforeStepInitializedHandler = () => {
    if (activeManageDeliveryTab !== ManageDeliverySegmentedControlSelection.ORDERS) {
      setActiveManageDeliveryTab(ManageDeliverySegmentedControlSelection.ORDERS);
    }
    if (!bottomSheetForcedSnapHeight || bottomSheetForcedSnapHeight < 650) {
      setBottomSheetForcedSnapHeight(650);
    }

    const eventHandler = () => {
      const segmentedControlItem = document
        .querySelectorAll('[data-qa="manage-delivery-segmented-control-item"]')[1]
        .querySelector('label') as HTMLElement;

      if (segmentedControlItem) {
        createMockPresenterElementOverOriginalElement(
          'segmented-control-item-copy-2',
          segmentedControlItem
        );
      }

      window.removeEventListener(
        DELIVERY_DASHBOARD_BOTTOM_SHEET_ANIMATION_COMPLETE_GLOBAL_EVENT_NAME,
        eventHandler
      );
    };
    if (bottomSheetForcedSnapHeight !== 650) {
      window.addEventListener(
        DELIVERY_DASHBOARD_BOTTOM_SHEET_ANIMATION_COMPLETE_GLOBAL_EVENT_NAME,
        eventHandler
      );
    } else {
      setTimeout(eventHandler, 50);
    }
  };

  const tutorialAfterAndHandler = () => {
    const copyItem1 = document.getElementById('segmented-control-item-copy') as any;
    const copyItem2 = document.getElementById('segmented-control-item-copy-2') as any;
    const extraHighlighter = document.getElementById('tutorial-marker-higlighter-5') as any;
    if (copyItem1) {
      document.body.removeChild(copyItem1);
    }
    if (copyItem2) {
      document.body.removeChild(copyItem2);
    }
    if (extraHighlighter) {
      document.body.removeChild(extraHighlighter);
    }
  };

  return {
    step3beforeStepInitializedHandler,
    step3beforeStepLeaveHandler,
    step4beforeStepInitializedHandler,
    step5beforeStepInitializedHandler,
    step5beforeStepLeaveHandler,
    step6beforeStepLeaveHandler,
    step6beforeStepInitializedHandler,
    tutorialAfterAndHandler,
  };
};
